// Context per gestire la lingua dell'applicazione
import React, { createContext, useContext, useState, useEffect } from 'react';
import { detectLanguage } from '../i18n/translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  // Rileva la lingua all'avvio
  const [language, setLanguage] = useState(() => {
    // Prova a recuperare dal localStorage, altrimenti rileva dal browser
    const savedLang = localStorage.getItem('foundly_language');
    return savedLang || detectLanguage();
  });

  // Salva la lingua nel localStorage quando cambia
  useEffect(() => {
    localStorage.setItem('foundly_language', language);
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'it' ? 'en' : 'it');
  };

  const value = {
    language,
    setLanguage,
    toggleLanguage
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};





















